import { Descriptions, Form, Input, Space } from 'antd';
import { ImageUpload } from '../../../components/form-item/ImageUpload';
import { useForm } from '@refinedev/antd';
import { useOne } from '@refinedev/core';

type Props = {
  childId: string;
};

export const ChildForm = ({ childId }: Props) => {
  const { data: childData } = useOne({
    resource: 'children',
    id: childId,
    meta: {
      fields: ['id', 'name', 'gender', 'ageYear', 'ageMonth', 'currentType'],
    },
  });
  const child = childData?.data;
  const { formProps } = useForm({
    resource: 'children',
    id: childId,
    action: 'edit',
    autoSave: {
      enabled: true,
      debounce: 500,
    },
    meta: {
      fields: ['id', { avatar: ['id', 'url'] }],
    },
    mutationMeta: {
      fields: [
        {
          child: ['id', { avatar: ['id', 'url'] }],
        },
      ],
    },
  });

  return (
    <Form {...formProps}>
      <Space>
        <Form.Item name="avatar" style={{ width: 110 }}>
          <ImageUpload />
        </Form.Item>
        <Descriptions
          bordered
          items={[
            { key: 'name', label: '名前', children: child?.name },
            { key: 'gender', label: '性別', children: child?.gender },
            { key: 'age', label: '年齢', children: `${child?.ageYear}歳${child?.ageMonth}ヶ月` },
            { key: 'currentType', label: '現在のタイプ', children: child?.currentType, span: 3 },
          ]}
        />
      </Space>
    </Form>
  );
};
